export const floatFormat =  (number, fixed) => {
	return ((Number(number)).toFixed(fixed).replace(/[.]?0+$/,""))
}